import Button from 'components/Button'
import { Link, useNavigate } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'

export function NavBar({ showHowItWorks = true, searchKeywords = [], setSearchKeywords, }) {
  const logo = "https://remote-recruit-email-temp.s3.us-east-1.amazonaws.com/website_images/SquarewhiteRR300.webp"
  const navigate = useNavigate()

  const toSignUp = () => {
    navigate('/auth')
  }

  const toHome = () => {
    navigate('/')
    if (searchKeywords.length > 0) {
      setSearchKeywords([])
    }
  }

  const toSignIn = () => {
    localStorage.setItem('emailExistsFromSignUp', false);
    navigate('/auth')
  }

  const handleClick = (event) => {
    event.preventDefault() // Prevent the default navigation behavior
    // Batch scrollIntoView to avoid forced reflow
    requestAnimationFrame(() => {
      const targetElement = document.getElementById('getStarted')
      targetElement?.scrollIntoView({ behavior: 'smooth' })
    })
  }

  return (
    <nav className="fixed top-0 w-full z-50 bg-[#00113C]/90 backdrop-blur-sm">
      <div className="mx-auto px-4 md:px-16 h-24 flex items-center justify-between">
        <div className="flex items-center gap-8">
          <Link href="/" className="flex items-center gap-2 h-full relative left-[-14px] md:left-[-19px]">
            <img
              src={logo}
              alt="RemoteRecruit"
              className="h-[100px] w-[94px] md:w-[120px] mt-0 md:mt-3"
              style={{ objectFit: 'contain' }}
              onClick={toHome}
              aria-label="RemoteRecruit"
              loading="lazy"
              width={120}
              height={100}
            />
          </Link>
          <div className="flex gap-[10.06px] sm:gap-6 ml-[37.8px] sm:ml-[90px]">
            {/* <p
              onClick={toHome}
              className="cursor-pointer text-white hover:text-white/80 text-[10px] sm:text-base not-italic font-bold sm:font-normal font-sans leading-normal"
            >
              Home
            </p>
            {showHowItWorks && (
              <Link
                href="/how-it-works"
                onClick={handleClick}
                className="text-white hover:text-white/80 text-[10px] sm:text-base not-italic font-bold sm:font-normal font-sans leading-normal"
              >
                How it Works?
              </Link>
            )} */}
          </div>
        </div>
        <div className="flex items-center gap-[7.6px] sm:gap-[14.676px] mt-0.5">
          <Button
            variant="ghost"
            className="text-white hover:text-white/80 w-[60px] sm:w-auto text-center py-[5.62px] px-2 sm:py-[11.741px] sm:px-[33.8px] text-base not-italic font-bold sm:font-normal font-sans leading-normal"
            onClick={toSignIn}
          >
            Sign In
          </Button>
          <Button
            className="bg-white text-[#062B7C] hover:bg-white/90 w-[60px] sm:w-auto text-center py-[5.62px] px-2 sm:py-[11.741px] sm:px-[33.8px] text-base not-italic font-bold sm:font-normal font-sans rounded-[2.108px] sm:rounded-[4.4px]"
            onClick={toSignUp}
          >
            Sign Up
          </Button>
        </div>
      </div>
    </nav>
  )
}
